export function projectRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_PROJECT_START":           
        case "FETCH_PROJECTS_START":                                 
        case "UPDATE_PROJECT_START":                                 
        case "ADD_SPENDING_TO_PROJECT_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_PROJECT_FULFILLED":           
        case "FETCH_PROJECTS_FULFILLED":                                 
        case "UPDATE_PROJECT_FULFILLED":                                 
        case "ADD_SPENDING_TO_PROJECT_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_PROJECT_ERROR":
        case "FETCH_PROJECTS_ERROR":
        case "UPDATE_PROJECT_ERROR":
        case "ADD_SPENDING_TO_PROJECT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}